/*
 * COPYRIGHT © 2026 SANITÀNEXUS WHITE-LABEL. ALL RIGHTS RESERVED.
 * AUTHOR AND SOLE DEVELOPER: MARCO PANZETTI (C.F. PNZMRC89M14F251C)
 * Protected under Italian Copyright Law (Legge 633/1941) and International Treaties.
 * Unauthorized copying, reverse engineering, or distribution of this software architecture,
 * UI/UX layouts, local-first logic, or system prompt configurations is strictly prohibited.
 */
import React from 'react';
import { BadgeCheck, ShieldCheck } from 'lucide-react';
import { cn } from '@/lib/utils';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';

/**
 * Small verified-professional badge shown next to a doctor's name.
 * `size` can be 'sm' | 'md' | 'lg'.
 * `variant` 'inline' | 'pill'
 */
export const VerifiedBadge = ({ verified = true, size = 'sm', variant = 'inline', albo, className, testId = 'verified-badge' }) => {
  if (!verified) return null;
  const dims = size === 'lg' ? 'h-5 w-5' : size === 'md' ? 'h-4 w-4' : 'h-3.5 w-3.5';
  const label = albo ? `Iscritto Albo n° ${albo.number}${albo.province ? ' (' + albo.province + ')' : ''}` : 'Professionista verificato';
  const inline = (
    <TooltipProvider delayDuration={100}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className={cn('inline-flex items-center justify-center text-primary', className)} data-testid={testId} aria-label={label}>
            <BadgeCheck className={cn(dims, 'fill-primary/15')} />
          </span>
        </TooltipTrigger>
        <TooltipContent side="top" className="text-xs">
          <div className="flex items-center gap-1.5"><ShieldCheck className="h-3.5 w-3.5 text-accent" /> {label}</div>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
  if (variant === 'inline') return inline;
  return (
    <span className={cn('inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-bold uppercase tracking-wider bg-primary/10 text-primary border border-primary/30', className)} data-testid={testId}>
      <BadgeCheck className={dims} /> Verificato
    </span>
  );
};

export default VerifiedBadge;
